<template>
    <div class="public_container invoice_confirmation_wrap" v-loading="formLoading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <ul class="list_content">
                <li class="list_content_item">
                    <p>
                        关联订单：<span class="link-label">{{ invoiceDetails.order_info.order_no }}</span>
                    </p>
                    <div class="mobile_detail_head_user_wrap">
                        客户联系人：
                        <div class="mobile_detail_head_user" v-if="invoiceDetails.order_info.contact_info" @click="handleClickUserInfo(invoiceDetails.order_info.contact_info)">
                            <img :src="invoiceDetails.order_info.contact_info.avatar
                                ? invoiceDetails.order_info.contact_info.avatar
                                : defaultImg
                                " alt="" />
                            <span class="ellipsis">{{
                                invoiceDetails.order_info.contact_info && invoiceDetails.order_info.contact_info.name
                            }}</span>
                        </div>
                    </div>
                    <p>订单总金额：{{ invoiceDetails.order_info.total_price }}</p>
                    <p>已回款金额：{{ invoiceDetails.order_info.repay_price }}</p>
                    <p>待回款金额：{{ invoiceDetails.order_info.no_repay_price }}</p>
                    <p>实际回款金额：{{ invoiceDetails.order_info.actual_repay_price }}</p>
                    <p>开票公司：{{ invoiceDetails.invoice_info.invoice_company_name }}</p>
                    <p>发票类型：{{ invoiceDetails.invoice_info.invoice_type_name }}</p>
                    <p v-if="
                        invoiceDetails.invoice_info.invoice_type === 1 || invoiceDetails.invoice_info.invoice_type === 2
                    ">
                        电子发票提供方式：{{ invoiceDetails.invoice_info.invoice_method_name || "--" }}
                    </p>
                    <p v-if="
                        invoiceDetails.invoice_info.invoice_type === 1 || invoiceDetails.invoice_info.invoice_type === 2
                    ">
                        电子收票邮箱：{{ invoiceDetails.invoice_info.invoice_email || "--" }}
                    </p>
                    <p>本次开票金额：{{ invoiceDetails.invoice_info.invoice_amount }}</p>
                    <p>开票对象：{{ invoiceDetails.invoice_info.invoice_title_type_name }}</p>
                    <p class="mb_4">开票信息：</p>
                    <div class="invoice_info_text" v-html="invoiceDetails.invoice_info.invoice_info"></div>
                    <template v-if="
                        invoiceDetails.invoice_info.invoice_type === 3 || invoiceDetails.invoice_info.invoice_type === 4
                    ">
                        <p>
                            收货人：{{
                                invoiceDetails.invoice_info.receive_name ? invoiceDetails.invoice_info.receive_name : "--"
                            }}
                        </p>
                        <p>
                            收货人电话：{{
                                invoiceDetails.invoice_info.receive_phone ? invoiceDetails.invoice_info.receive_phone : "--"
                            }}
                        </p>
                        <p>
                            收货地址：{{
                                invoiceDetails.invoice_info.receive_addr ? invoiceDetails.invoice_info.receive_addr : "--"
                            }}
                        </p>
                    </template>
                    <div>
                        <p class="mb_4">备注:</p>
                        <p>{{ invoiceDetails.invoice_info.remark }}</p>
                    </div>
                    <p>附件：</p>
                    <div v-if="invoiceDetails.invoice_info.attachments && invoiceDetails.invoice_info.attachments.length">
                        <ul class="voucher_list">
                            <li :key="imgIndex" class="voucher_item" v-for="(img, imgIndex) in invoiceDetails.invoice_info.attachments" @click="
                                handleClickPreviewImg(
                                    imgIndex,
                                    invoiceDetails.invoice_info.attachments.map((item) => item.file_path)
                                )
                                ">
                                <van-image :src="img.file_path" alt=""> </van-image>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            <van-form label-width="9.5em" input-align="right" scroll-to-error :show-error-message="false" ref="invoiceConfirmationForm" class="custom_mobile_form">
                <van-field required v-model="invoiceForm.invoice_number" name="invoice_number" label="发票号码" placeholder="请输入" :rules="[{ required: true, message: '请输入' }]">
                </van-field>
                <van-field v-model="invoiceForm.finance_remark" name="finance_remark" label="财务备注" placeholder="请输入" rows="4" maxlength="200" autosize type="textarea"
                    input-align="left" class="vertical_input_wrap">
                </van-field>
                <van-field name="voucher" label="附件" class="vertical_input_wrap">
                    <template #input>
                        <div class="upload_input_wrap">
                            <ul class="voucher_list">
                                <li :key="index" class="voucher_item" v-for="(item, index) in invoiceForm.finance_attachments">
                                    <van-image :src="item" alt=""> </van-image>
                                    <i @click="invoiceForm.finance_attachments.splice(index, 1)" class="iconfont icon-guanbi_dise"></i>
                                </li>
                                <li @click="handleClickUploadFile" class="upload_img_wrap">
                                    <i class="el-icon-plus"></i>
                                </li>
                            </ul>
                            <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
                        </div>
                    </template>
                </van-field>
            </van-form>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
    </div>
</template>
<script>
import { InvoiceDetail, InvoiceConfirm } from "@/api";
import { uploadImg } from "@/utils/uploadOss";
import { ImagePreview } from "vant";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "InvoiceConfirmation",
    components: { ReturnNavBar },
    data() {
        return {
            formLoading: false,
            invoice_no: "",
            defaultImg: require("@/assets/images/default.jpg"),
            invoiceDetails: {
                order_info: {}, // 订单信息
                invoice_info: {}, // 开票信息
                other_info: {}, // 其它信息
            },
            invoiceForm: {
                invoice_no: "",
                invoice_number: "",
                finance_remark: "",
                finance_attachments: [],
            },
            btnDisabled: false,
        };
    },
    created() {
        if (this.$route.query) {
            this.invoice_no = this.$route.query.invoice_no;
            this.getInvoiceDetail();
        }
    },
    methods: {
        // 详情
        getInvoiceDetail() {
            InvoiceDetail({ invoice_no: this.invoice_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.invoiceDetails = data;
                }
            });
        },
        // 上传图片
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024)) return that.$toast("图片大小不允许超过5m");
                if (that.invoiceForm.finance_attachments.length + files.length > 5) return that.$toast("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.invoiceForm.finance_attachments.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        handleClickConfirm() {
            this.$refs.invoiceConfirmationForm.validate().then(() => {
                this.btnDisabled = true
                this.formLoading = true;
                let params = {
                    invoice_no: this.invoice_no,
                    invoice_number: this.invoiceForm.invoice_number,
                    finance_remark: this.invoiceForm.finance_remark,
                    finance_attachments: this.invoiceForm.finance_attachments,
                };
                InvoiceConfirm(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.btnDisabled = false;
                            this.formLoading = false;
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                        this.formLoading = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.invoice_confirmation_wrap {
    .mobile_container {
        background-color: #ffffff;

        .voucher_list {
            margin-top: 10px;
            padding: 0;
            display: flex;
            gap: 8px;

            .voucher_item {
                width: 44px;
                height: 44px;
                cursor: pointer;
                position: relative;
                text-align: center;
                line-height: 44px;
                border-radius: 4px;

                .van-image {
                    max-width: 100%;
                    max-height: 100%;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }

                .icon-guanbi_dise {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    cursor: pointer;
                    font-size: 16px;
                    color: rgba(191, 191, 191, 1);
                    line-height: 16px;
                }
            }
        }
    }

    .add_footer_wrap {
        padding: 5px 16px;
        background-color: rgba(247, 248, 250, 1);

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }

    .invoice_info_text {
        padding: 6px;
        border-radius: 6px;
        background: #f0f0f0;

        p {
            &+p {
                margin-top: 8px;
            }

            span {
                display: block;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(51, 51, 51, 1);
            }
        }
    }
}

.list_content {
    padding: 10px 16px 16px;
    border-bottom: 1px solid #ebedf0;

    .list_content_item {
        border-radius: 6px;
        background: rgba(249, 249, 249, 1);
        padding: 8px 10px 2px;
        margin-bottom: 8px;

        &>p,
        &>div {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);
            margin-bottom: 8px;
        }
    }

    .form_module_content {
        padding: 0;
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
